import { IconButton } from "@material-ui/core";
import { CloseRounded } from "@material-ui/icons";
import React, { useState } from "react";
import { MinPreview } from "./styles";

export default function ThumbPreview({ removeImage, ...props }) {
  return (
    <MinPreview {...props}>
      <IconButton
        onClick={removeImage}
        className="remove-image"
        style={{
          marginRight: 2,
          width: 5,
          height: 5,
          backgroundColor: "var(--c2s-red)",
        }}
      >
        <CloseRounded style={{ color: "#FFF", fontSize: 12 }} />
      </IconButton>
    </MinPreview>
  );
}
